import { render } from "./Spacer.vue?vue&type=template&id=578e578d"
import script from "./Spacer.vue?vue&type=script&lang=js"
export * from "./Spacer.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/jenkins/workspace/suiteweb-web-components_gamma/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__